/**
 * This is an auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import type { ApiAddress, ApiCreateAddressRequest, LockElement, LockedContextDto } from '@Model';
import type { HttpActions, ListInfo, ListRequest, ListRequestWithIds, Result } from '@synqo/frontend-component-library';

/**
 * Calls the endpoints of AddressesController.
 */
export class AddressesRepository {
    constructor(private readonly http: HttpActions) {}

    /**
     * Calls POST /addresses:prefill
     */
    public createPrefilledAddress(apiCreateAddressRequest: ApiCreateAddressRequest | undefined): Promise<Result<ApiAddress>> {
        return this.http.post<Result<ApiAddress>, ApiCreateAddressRequest | undefined>('/addresses:prefill', apiCreateAddressRequest);
    }

    /**
     * Calls GET /addresses/{primaryId}
     */
    public get(primaryId: string, include: string | undefined): Promise<Result<ApiAddress>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ApiAddress>>(`/addresses/${primaryId}`, query);
    }

    /**
     * Calls POST /addresses:batch
     */
    public getBatch(listRequest: ListRequestWithIds, include: string | undefined): Promise<Result<ListInfo<ApiAddress>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiAddress>>, ListRequestWithIds>('/addresses:batch', listRequest, query);
    }

    /**
     * Calls POST /addresses:query
     */
    public getListPost(listRequest: ListRequest, include: string | undefined): Promise<Result<ListInfo<ApiAddress>>> {
        const query = new URLSearchParams();
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.post<Result<ListInfo<ApiAddress>>, ListRequest>('/addresses:query', listRequest, query);
    }

    /**
     * Calls POST /addresses
     */
    public add(dto: ApiAddress): Promise<Result<ApiAddress>> {
        return this.http.post<Result<ApiAddress>, ApiAddress>('/addresses', dto);
    }

    /**
     * Calls PUT /addresses/{primaryId}
     */
    public update(dto: ApiAddress, primaryId: string): Promise<Result<ApiAddress>> {
        return this.http.put<Result<ApiAddress>, ApiAddress>(`/addresses/${primaryId}`, dto);
    }

    /**
     * Calls PATCH /addresses
     */
    public putRange(dtos: ApiAddress[]): Promise<Result<ApiAddress[]>> {
        return this.http.patch<Result<ApiAddress[]>, ApiAddress[]>('/addresses', dtos);
    }

    /**
     * Calls DELETE /addresses/{primaryId}
     */
    public delete(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/addresses/${primaryId}`);
    }

    /**
     * Calls POST /addresses/{draftId}/commit
     */
    public commitDraft(draftId: string): Promise<Result<ApiAddress>> {
        return this.http.post<Result<ApiAddress>, undefined>(`/addresses/${draftId}/commit`, undefined);
    }

    /**
     * Calls POST /addresses/{primaryId}/start_edit_mode
     */
    public startEditMode(primaryId: string): Promise<Result<LockedContextDto<ApiAddress>>> {
        return this.http.post<Result<LockedContextDto<ApiAddress>>, undefined>(`/addresses/${primaryId}/start_edit_mode`, undefined);
    }

    /**
     * Calls POST /addresses/locks
     */
    public lockAll(ids: string[]): Promise<Result<ApiAddress[]>> {
        return this.http.post<Result<ApiAddress[]>, string[]>('/addresses/locks', ids);
    }

    /**
     * Calls POST /addresses/{primaryId}/locks
     */
    public lock(primaryId: string): Promise<Result<LockElement>> {
        return this.http.post<Result<LockElement>, undefined>(`/addresses/${primaryId}/locks`, undefined);
    }

    /**
     * Calls DELETE /addresses/{primaryId}/locks
     */
    public unlock(primaryId: string): Promise<Result<boolean>> {
        return this.http.delete<Result<boolean>>(`/addresses/${primaryId}/locks`);
    }

    /**
     * Calls GET /addresses:query
     */
    public getListGet(pageNo: number, pageSize: number, include: string | undefined): Promise<Result<ListInfo<ApiAddress>>> {
        const query = new URLSearchParams();
        query.set('pageNo', `${pageNo}`);
        query.set('pageSize', `${pageSize}`);
        if (include !== undefined) {
            query.set('include', `${include}`);
        }

        return this.http.get<Result<ListInfo<ApiAddress>>>('/addresses:query', query);
    }
}
